import React, { Fragment } from 'react';
import { Tooltip } from 'react-tooltip';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import 'styles/_help-tooltip.scss';

const LinkTooltip = ({ id, tooltip, className }) => (
  <a className={classNames('help-tooltip', className)} tabIndex={0} aria-label={tooltip.replace("<br />"," ")} aria-describedby={id} data-tooltip-id={id}>
    <i className="fa fa-question" />
  </a>
);

LinkTooltip.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  tooltip: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

const HelpTooltip = ({
  id, tooltip, className, children, place='top'
}) => (
  <Fragment>
    <Tooltip
      role="tooltip"
      place={place}
      className={classNames('help-tooltip-content', className)}
      id={id}
      render={() => <span dangerouslySetInnerHTML={{ __html: tooltip }} />}
    />
    {!children && (
      <LinkTooltip id={id} tooltip={tooltip} className={className} />
    )}
    {children && (
      <span>
        <span style={{ marginRight: '5px' }}>
          {children}
        </span>
        <LinkTooltip id={id} tooltip={tooltip} className={className} />
      </span>
    )}
  </Fragment>
);

HelpTooltip.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  tooltip: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.any
};

HelpTooltip.defaultProps = {
  className: '',
  children: null,
};

export default HelpTooltip;
